'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalPrintshop = function MapsLocalPrintshop(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z' })
  );
};
MapsLocalPrintshop = (0, _pure2.default)(MapsLocalPrintshop);
MapsLocalPrintshop.displayName = 'MapsLocalPrintshop';
MapsLocalPrintshop.muiName = 'SvgIcon';

exports.default = MapsLocalPrintshop;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/maps/local-printshop.js
 ** module id = 2217
 ** module chunks = 0
 **/